import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { RolePermission, RolePermissionService } from '../auth/rbac/role-permission.service';

/** Menu and shell: recommendations or anomalies. Finance (forecast only) stays out until a Forecasts tab exists. */
@Injectable()
export class AiInsightsAccessGuard {
  constructor(
    private permissions: RolePermissionService,
    private router: Router,
  ) {}

  canActivate(): boolean | UrlTree {
    if (this.permissions.hasPermissions([RolePermission.AI_INSIGHT_READ, RolePermission.AI_ANOMALY_READ])) {
      return true;
    }
    return this.router.parseUrl('/forbidden');
  }
}

/** Empty /ai-insights goes to the first tab this user can open, including inside the publisher portal. */
@Injectable()
export class AiInsightsLandingGuard {
  constructor(
    private permissions: RolePermissionService,
    private router: Router,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): UrlTree {
    const path = state.url.split('?')[0].replace(/\/$/, '');
    if (this.permissions.hasPermissions([RolePermission.AI_INSIGHT_READ])) {
      return this.router.parseUrl(`${path}/recommendations`);
    }
    if (this.permissions.hasPermissions([RolePermission.AI_ANOMALY_READ])) {
      return this.router.parseUrl(`${path}/anomalies`);
    }
    return this.router.parseUrl('/forbidden');
  }
}

/** Child route. data.permission is the single permission that may open this tab. */
@Injectable()
export class AiInsightsTabGuard {
  constructor(
    private permissions: RolePermissionService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const permission = route.data['permission'] as RolePermission;
    if (permission && this.permissions.hasPermissions([permission])) {
      return true;
    }
    return this.router.parseUrl('/forbidden');
  }
}
